import { DatePipe, I18nPluralPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import type { VenueStorefrontBookingSearch } from '../venue-storefront-booking-flow/venue-storefront-booking-flow.types'

@Component({
    selector: 'app-venue-storefront-booking-progress-summary',
    standalone: true,
    imports: [DatePipe, I18nPluralPipe],
    templateUrl: './venue-storefront-booking-progress-summary.component.html',
    styleUrls: ['./venue-storefront-booking-progress-summary.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VenueStorefrontBookingProgressSummaryComponent {
    search = input.required<VenueStorefrontBookingSearch>()
    backDisabled = input(false)
    back = output<void>()

    protected readonly partySizePluralMapping = {
        '=1': '1 person',
        other: '# people',
    }
}
